export const revenueOperationsTransactionsArticle = {
  title: 'Revenue Operations Hub: Transactions',
  slug: 'revenue-operations-transactions',
  content: `Revenue Operations Hub: Transactions

Use Transactions to capture revenue and expenses in one log.

1) Open Transactions
- Go to /finance-hub.
- Select the Transactions tab (#transactions).

2) Record sales
- Use the Sales toggle to log revenue entries.
- Recent sales appear in the table below the form.

3) Record expenses
- Switch to Expenses to log spend by category.
- Recent expenses appear in the table below the form.

4) Keep data consistent
- Use clear categories so Dashboard and Insights remain accurate.
`,
};
